// initial state
const projectStatusEnum = {
  OPEN: 1,
  REVIEW: 20,
  ACHIEVEMENT: 30,
  CLOSE: 40,
  BU_APPROVE: 50,
  FIRST_APPROVE: 60,
  SECOND_APPROVE: 70,
  REJECTED: 80,

}

const projectArchiveStatusEnum = {
  NO: 0,
  YES: 1,
}

const projectNeedApprove = {
  NEED_BU_APPROVE: 1,
  NEED_FIRST_APPROVE: 2,
  NEED_SECOND_APPROVE: 3,
  NEED_FINANCE_APPROVE: 4,
}

const state = {
  options: {
    status: [
      {label: '开立', value: projectStatusEnum.OPEN},
      {label: '审核中', value: projectStatusEnum.REVIEW},
      {label: '审核中', value: projectStatusEnum.BU_APPROVE},
      {label: '审核中', value: projectStatusEnum.FIRST_APPROVE},
      {label: '审核中', value: projectStatusEnum.SECOND_APPROVE},
      {label: '完成', value: projectStatusEnum.ACHIEVEMENT},
      {label: '关闭', value: projectStatusEnum.CLOSE},
      {label: '已驳回', value: projectStatusEnum.REJECTED},
    ],
    approve_status: [
      {label: '待BO审批', value: projectNeedApprove.NEED_BU_APPROVE},
      {label: '待一级审批', value: projectNeedApprove.NEED_FIRST_APPROVE},
      {label: '待二级审批', value: projectNeedApprove.NEED_SECOND_APPROVE},
      {label: '待财务审批', value: projectNeedApprove.NEED_FINANCE_APPROVE},
    ],
    archive_status: [
      {label: '未归档', value: projectArchiveStatusEnum.NO},
      {label: '已归档', value: projectArchiveStatusEnum.YES},
    ],
    project_status: [
      {label: '开立', value: [projectStatusEnum.OPEN], key: 1},
      {
        label: '审核中',
        value: [
          projectStatusEnum.REVIEW,
          projectStatusEnum.BU_APPROVE,
          projectStatusEnum.FIRST_APPROVE,
          projectStatusEnum.SECOND_APPROVE
        ],
        key: 2
      },
      {label: '完成', value: [projectStatusEnum.ACHIEVEMENT], key: 3},
      {label: '关闭', value: [projectStatusEnum.CLOSE], key: 4},
      {label: '已驳回', value: [projectStatusEnum.REJECTED], key: 5},
    ],
  },
  statusEnum: projectStatusEnum
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const customerProjectcost = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/customer-projectcost/customer-projectcost.store.js